import { useEffect } from "react";
import { Link } from "react-router-dom";

const STORIES = [
  { slug: "bring-it-on", title: "Bring It On", mood: "Defiant · Faith",
    excerpt: "A bold opening declaration about stepping into the fight with faith and resolve. Sets the tone for confronting spiritual and real-world battles without fear." },
  { slug: "holy-ghost", title: "Holy Ghost", mood: "Reflective · Renewal",
    excerpt: "A reflective song about repentance, renewal, and honoring God's presence after seasons of brokenness. Transformation through surrender." },
  { slug: "philly-foster-kid", title: "Philly Foster Kid", mood: "Grounded · Anthemic",
    excerpt: "A grounded, place-based story inspired by real streets, systems, and children in Philadelphia's foster care system — humanizing lives often reduced to numbers." },
  { slug: "all-you-gotta-do-is-believe", title: "All You Gotta Do Is Believe", mood: "Faith · Healing",
    excerpt: "A meditation on unbridled faith and healing. Reflects on receiving what God has already sent, even when doubt tries to interfere." },
  { slug: "we-all-got-history", title: "We All Got History", mood: "Reflective · Cinematic",
    excerpt: "A reflection on how personal and collective history shapes identity. Acknowledges the past without being trapped by it." },
  { slug: "how-long", title: "How Long?", mood: "Lament · Endurance",
    excerpt: "A lament born from frustration and endurance. Voices the ache of waiting — for justice, healing, and change — to finally arrive." },
  { slug: "lost-then-found", title: "Lost Then Found", mood: "Compassion · Calling",
    excerpt: "Inspired by children scattered across systems and forgotten spaces. Calls for compassion, accountability, and a heart-led response." },
  { slug: "the-next-time-i-see-you", title: "The Next Time I See You", mood: "Regret · Forgiveness",
    excerpt: "A song about regret, forgiveness, and second chances — imagining what healing could look like if reconciliation were possible." },
];

export default function BehindTheSongs() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div data-testid="behind-the-songs-page">
      <section className="border-b border-fc-border">
        <div className="container-xl pt-20 pb-14">
          <div className="overline text-fc-muted mb-5">Behind the Songs</div>
          <h1 className="font-display text-5xl md:text-7xl leading-[0.95] max-w-4xl">
            Every song is a <span className="italic text-fc-accent">chapter.</span>
          </h1>
          <p className="mt-6 text-fc-muted max-w-2xl">
            The stories, themes, and scripture behind the anthems — written to honor lived experience and serve the mission.
          </p>
        </div>
      </section>

      <section className="container-xl py-16">
        <div className="border-t border-fc-border">
          {STORIES.map((s, i) => (
            <div key={s.slug} className="grid md:grid-cols-12 gap-6 py-10 border-b border-fc-border">
              <div className="md:col-span-2">
                <div className="font-mono text-sm text-fc-muted">{String(i+1).padStart(2,"0")}</div>
              </div>
              <div className="md:col-span-7">
                <div className="overline text-fc-accent mb-2">{s.mood}</div>
                <h3 className="font-display text-3xl md:text-4xl leading-tight mb-3">{s.title}</h3>
                <p className="text-fc-muted leading-relaxed max-w-2xl">{s.excerpt}</p>
              </div>
              <div className="md:col-span-3 flex md:justify-end items-start">
                <Link to={`/anthem/song/${s.slug}`} className="overline link-ul text-fc-ink" data-testid={`bts-song-${s.slug}`}>
                  Open Track →
                </Link>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
